import {Component, Directive, HostListener, Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Destroyable} from './destroyable';

@Directive({})
export abstract class ContextMenu extends Destroyable {
    private touchTimeout: any;

    // Right-click on web
    @HostListener('contextmenu', ['$event'])
    onRightClick(event: MouseEvent) {
        if (!Capacitor.isNativePlatform()) { // Only trigger on web
            event.preventDefault();
            this.handle(event);
        }
    }

    // Long press on mobile (Capacitor)
    @HostListener('touchstart', ['$event'])
    onTouchStart(event: TouchEvent) {
        if (Capacitor.isNativePlatform()) { // Only trigger on mobile
            this.touchTimeout = setTimeout(() => {
                this.handle(event);
            }, 500); // 500ms threshold for long press
        }
    }

    @HostListener('touchmove')
    onTouchMove() {
        clearTimeout(this.touchTimeout); // Cancel long press
    }

    @HostListener('touchend')
    onTouchEnd() {
        clearTimeout(this.touchTimeout); // Cancel if released early
    }

    abstract handle(event: Event): void;
}
